import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.scss'],
})
export class PrimaryButtonComponent implements OnInit {
  @Input() public title = 'BUTTON.CONTINUE';
  @Input() public skipTitle = 'BUTTON.SKIP';
  @Input() public nextStep = '';
  @Input() public link = null;
  @Input() public isSkip = true;
  @Input() public isCentered = false;
  @Input() public disabled = false;
  @Input() public isCanSubmit = true;
  @Output() public action = new EventEmitter();
  @Output() public skip = new EventEmitter();
  constructor(private router: Router) {}

  public ngOnInit(): void {}

  public onSubmit() {
    if (this.link) {
      this.router.navigate(['entry-summary', this.link]);
    }
    if (this.action.observers.length > 0) {
      this.action.emit();
    }
  }

  public onSkip() {
    this.skip.emit();
  }
}
